import React from 'react';
import { Check } from 'lucide-react';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage } from '../../components';
import { getIcon } from '../iconMap';

function DocumentsPair({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const r = data.registration || {};
  const a = data.admission || {};
  const RI = getIcon(r.icon);
  const AI = getIcon(a.icon);
  const updateR = (patch) => update({ registration: { ...r, ...patch } });
  const updateA = (patch) => update({ admission: { ...a, ...patch } });
  const updateRItem = (i, t) => {
    const list = [...(r.items || [])];
    list[i] = t;
    updateR({ items: list });
  };
  const updateAItem = (i, t) => {
    const list = [...(a.items || [])];
    list[i] = t;
    updateA({ items: list });
  };
  return (
    <section className="py-24 bg-white">
      <div className="container-page grid lg:grid-cols-2 gap-8">
        <Reveal>
          <div className="card-surface p-8 h-full">
            <h3 className="font-display text-2xl flex items-center gap-3"><RI className="text-olive" /> <EditableText value={r.title} onChange={(t) => updateR({ title: t })} as="span" /></h3>
            <ul className="mt-5 space-y-3 text-sm text-ink/75">
              {(r.items || []).map((d, i) => (
                <li key={i} className="flex gap-3"><Check size={16} className="text-olive shrink-0 mt-1" /><EditableText value={d} onChange={(t) => updateRItem(i, t)} as="span" /></li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="card-surface p-8 h-full">
            <h3 className="font-display text-2xl flex items-center gap-3"><AI className="text-olive" /> <EditableText value={a.title} onChange={(t) => updateA({ title: t })} as="span" /></h3>
            <ul className="mt-5 space-y-3 text-sm text-ink/75">
              {(a.items || []).map((d, i) => (
                <li key={i} className="flex gap-3"><Check size={16} className="text-olive shrink-0 mt-1" /><EditableText value={d} onChange={(t) => updateAItem(i, t)} as="span" /></li>
              ))}
            </ul>
            {a.image && (
              <EditableImage
                src={a.image.src}
                alt={a.image.alt || 'Admissions'}
                onChange={(src, alt) => updateA({ image: { src, alt } })}
                className="mt-6 rounded-2xl h-48 w-full object-cover"
              />
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default DocumentsPair;
